import { OwnProps } from '~/types/ownProps';

function meetsDataDependencies(props: OwnProps) {
  const {
    application: { hasHome },
  } = props;

  return hasHome;
}

const step = {
  route: '/homeowners-insurance/quotes/discounts',
  isAccessible: ({ application }: OwnProps) => !application.isAutoOnly,
  breadcrumbStep: 'property',
  meetsDataDependencies,
};

export default step;
